import cryptoStandard from "./builtins/crypto-standard.json";
import emaMulti from "./builtins/ema-multi.json";
import orderflowSuite from "./builtins/orderflow-suite.json";
import vnSwingSetup from "./builtins/vn-swing-setup.json";
export const BUILTIN_INDICATOR_SETS = [
    vnSwingSetup,
    emaMulti,
    orderflowSuite,
    cryptoStandard,
];
